<template>
    <div class="layout__padding-clear">
        <div class="layout__position__relative">
            <img class="layout__width-100 layout__height-100 layout__padding-clear"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/banners/Directmailr-banner--new.jpg">

            <div class="layout__padding-clear">
                <div class="component__banner-subtitle component__banner-subtitle--dm layout__padding-clear">
                    <div class="text__align-center">
                        <el-button class="button__background-red button__base__header-large layout__width-350px layout__margin__right-280px"
                                   v-on:click="validateUser()">Get Started from just 57p per mailer
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="text__align-center layout__padding-20-0">
            <h2 class="text__colour-teal layout__padding-20-0">Prospecting made easy</h2>

            <iframe src="https://player.vimeo.com/video/610656577?h=d3160af371&title=0&byline=0" width="900" height="500" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

            <h2 class="text__colour-teal layout__padding-50-0">Reach your target market and future-proof<br>your pipeline in just three simple steps.</h2>

            <div class="layout__padding-clear layout__width-900px">
                <div class="layout__height-300px layout__margin-30-0">
                    <div class="component__columns-2">
                        <img class="layout__width-400px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/Refine_Your_Audience.jpg">
                    </div>

                    <div class="component__columns-2 layout__padding__top-70px">
                        <img class="layout__width-50px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/refine-your-audience.svg">
                        <h3 class="text__colour-teal component__im-h3-steps layout__position-top-minus-10">Refine your audience</h3>
                        <p>Use our household or 'on market' data to build your<br>mailing list and refine your audience based on property<br>type, council tax band, length of residency and more.</p>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-900px">
                <div class="layout__height-300px layout__margin-30-0">
                    <div class="component__columns-2">
                        <img class="layout__width-400px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/Direct_Mail_Template.jpg">
                    </div>

                    <div class="component__columns-2 layout__padding__top-70px">
                        <img class="layout__width-50px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/direct-mail-template.svg">
                        <h3 class="text__colour-teal component__im-h3-steps">Edit your chosen<br>direct mail template</h3>
                        <p>Create your campaign using one of the professionally<br>designed <a href="http://ravensworth.co.uk/wp-content/uploads/2021/09/Directmailr-Template-Collection-2021.pdf" target="new" class="link__colour-red">direct mail templates</a>
                        , or speak to us about<br>uploading your own bespoke designs.</p>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-900px">
                <div class="layout__height-300px layout__margin-30-0">
                    <div class="component__columns-2">
                        <img class="layout__width-400px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/Print_And_Post.jpg">
                    </div>

                    <div class="component__columns-2 layout__padding__top-70px">
                        <img class="layout__width-50px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/print-and-post.svg">
                        <h3 class="text__colour-teal component__im-h3-steps layout__position-top-minus-5">Print and post your targeted<br>prospecting campaign</h3>
                        <p>Check and confirm your requirements, then we'll print<br>and post your prospecting campaign to help you win<br>new instructions.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="text__align-center">
            <div class="text__align-center">
                <el-button class="button__background-red-border button__base__header-large layout__width-200px"
                            v-on:click="createCreditAccount()">Create your account
                </el-button>
            </div>
        </div>

        <div class="text__align-center layout__padding__top-40px">
            <p class="component__im-footer">
                *Using Directmailr<span class="text__size-10 layout__position-top">TM</span> on MyRavensworth is <span class="text__style-bold text__colour-black">free of charge</span>, but to access this application you will need to set up a credit account. We don't charge for <span class="text__style-bold text__colour-black">creating your account</span><br>
                and there are <span class="text__style-bold text__colour-black">no contracts</span> or monthly subscriptions. You will only be invoiced for the data you use and the number of mailers you choose to print and post each month.
            </p>
        </div>

        <!--<div class="layout__padding-clear" v-show="showTermsOfService">-->
            <el-dialog
                    :visible.sync="showTermsOfService"
                    width="500px">
                <div class="text__size-22 text__align-center text__colour-teal layout__margin__bottom-20">Terms of Service</div>
                <div class="text__size-22 text__align-center layout__margin__top-20 layout__margin__bottom-20 text__line-height-12">
                    Before using our Directmailr<br>Service please ensure you have read,<br>understood and agree to our terms and<br>conditions and privacy policy.<br>
                </div>
                <div class="layout__margin__top-20 layout__margin__bottom-20 layout__margin__left-50 terms-of-service">
                    <el-checkbox v-model="termsAndConditionsChecked">I have read and agree to the <a href="https://ravensworth.co.uk/terms-and-conditions/" target="new">Terms & Conditions</a></el-checkbox>
                    <el-checkbox v-model="privacyPolicyChecked">I have read and agree to the <a href="https://ravensworth.co.uk/privacy-policy/" target="new">Privacy Policy</a></el-checkbox>
                </div>

                <div class="text__align-center layout__margin__top-50">
                    <el-button class="button__background-red-border button__base__header-large layout__width-200px" :disabled="termsAndConditionsChecked == false || privacyPolicyChecked == false"
                                v-on:click="continueToInstantMarketing()">Continue
                    </el-button>
                </div>
            </el-dialog>
        <!--</div>-->

        <el-dialog
                :visible.sync="notAccountUsers"
                width="500px">
            <div class="layout__position-center text__align-center">
                <h2 class="text__colour-teal">Create your account</h2>
                <h3 class="text__colour-teal layout__padding-20-0">
                  Register for a FREE MyRavensworth account <br>
                  in minutes to get access to our online services <br>
                  including Directmailr™. <br>
                  <br>
                  Click below to get started.
                </h3>

                <div class="">
                    <el-button class="button-red button__base layout__position-center layout__width-200px"
                               v-on:click="openLoginModal(true)">Start using Directmailr™
                    </el-button>
                </div>

                <p class="layout__cursor-pointer layout__padding-20-0" v-on:click="openLoginModal(false)">
                  Already have an account?<br>
                  <span class="text__colour-teal">
                    Click here to log in
                  </span>
                </p>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="createAccountDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                :before-close="resetAccountForm"
                custom-class="credit-application-dialog">
            <div class="component__login-dialogue layout__padding-clear" v-show="createAccountDialog">
                <CreditApplication v-on:closeAccount="createAccountDialog = false" account_type="ACCOUNT" payment_method="MONTHLYEMAILINVOICE" ref="createAccount"></CreditApplication>
                <el-button id="createAccountDialog" class="layout__display-none"
                           v-on:click="createAccountDialog = false"></el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import Axios from 'axios';
    import {Loading} from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import Router from '../../../router';
    import Login from '../../Login.vue';
    import CreditApplication from '../../CreditApplication.vue';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "generateaquote",
        props: {},
        components: {
            Login,
            CreditApplication,
            Stepguide
        },
        mixins: [axios, dataFormatter, backing],
        computed: {
            readAndAgreedChecked() {
                if (this.termsAndConditionsChecked == 1 && this.privacyPolicyChecked == 1) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        data() {
            return {
                showTermsOfService: false,
                notAccountUsers: false,
                createAccountDialog: false,
                termsAndConditionsChecked: false,
                privacyPolicyChecked: false,
                customer: {},
            }
        },
        beforeUpdate() {
        },
        created() {
            if (this.$route.params.showPopup) {
              // this.notAccountUsers = true;

              document.getElementById('openLoginClosable').click();

              this.$route.params.showPopup = false;
            }

            if (this.returnCookie('_token') === null) {
                window.sessionStorage.setItem('_routerFrom', this.$route.path)
            }
        },
        methods: {
          validateUser() {
            if (window.sessionStorage.getItem('_customer')) {
              const terms_of_service_accepted = this.readCookie('terms_of_service_accepted');

              if (terms_of_service_accepted === "undefined") {
                this.showTermsOfService = true;
              } else {
                if (terms_of_service_accepted !== 'true') {
                  this.showTermsOfService = true;
                } else {
                  this.showTermsOfService = false;
                  this.termsAndConditionsChecked = 1;
                  this.privacyPolicyChecked = 1;
                  this.continueToInstantMarketing();
                }
              }
            } else {
              document.getElementById('openLoginClosable').click();
            }
          },

            validateAccountUser() {
                if (window.sessionStorage.getItem('_customer') === 'undefined' || window.sessionStorage.getItem('_customer') === null) {
                    if (JSON.parse(this.returnCookie('_role')) !== null && JSON.parse(this.returnCookie('_role')).includes('AccountCustomer')) {
                        this.notAccountUsers = false;

                        Router.push({
                            name: '/directmailr/place-order'
                        });
                    } else {
                        // this.notAccountUsers = true

                      document.getElementById('openLoginClosable').click();
                    }
                } else {
                    this.customer = JSON.parse(window.sessionStorage.getItem('_customer'));

                    if (this.customer.accountType !== undefined && this.customer.accountType == 'ACCOUNT') {
                        this.notAccountUsers = false;

                        var terms_of_service_accepted = this.readCookie('terms_of_service_accepted');
                        console.log('terms_of_service_accepted=' + terms_of_service_accepted);

                        if (terms_of_service_accepted === "undefined") {
                            this.showTermsOfService = true;
                        } else {
                            if (terms_of_service_accepted !== 'true') {
                                this.showTermsOfService = true;
                            } else {
                                this.showTermsOfService = false;
                                this.termsAndConditionsChecked = 1;
                                this.privacyPolicyChecked = 1;
                                this.continueToInstantMarketing();
                            }
                        }
                    } else {
                        this.showTermsOfService = false;
                        // this.notAccountUsers = true;

                      document.getElementById('openLoginClosable').click();
                    }
                }
            },
            continueToInstantMarketing() {
                if (this.readAndAgreedChecked) {
                    var expiration_date = new Date(),
                        cookie_string = '';
                    expiration_date.setFullYear(expiration_date.getFullYear() + 2);
                    cookie_string = "terms_of_service_accepted=true; path=/; expires=" + expiration_date.toUTCString();
                    document.cookie = cookie_string;

                    Router.push({
                        name: '/directmailr/place-order'
                    });
                }
            },
            openLoginModal(register = false) {
                this.notAccountUsers = false;
                document.getElementById('openLoginClosable').click();

                if (register) {
                  this.$nextTick(() => {
                    global.vm.$children[0].$refs.loginClosable.activeForm = 'register';
                  });
                }
            },
            // findOutMore() {
            //     window.open('https://ravensworth.co.uk/our-tech/directmailr', '_blank');
            // },
            createCreditAccount() {
                this.createAccountDialog = true;
                this.notAccountUsers = false;
            },
            resetAccountForm(done) {
                this.$refs.createAccount.resetForm();
                done();
            },
            readCookie(name) {
                var cookieArr = document.cookie.split('; '),
                    cookiePair;

                for (var i = 0; i < cookieArr.length; i++){
                    cookiePair = cookieArr[i].split('=');
                    if (name == cookiePair[0].trim()) {
                        return decodeURIComponent(cookiePair[1]);
                    }
                }

                return null;
            },
        },
    };
</script>
